<div class="soft-page">
  <div class="content-wrapper">

    <div class="header-section">
      <p class="page-title">Impostazioni Monitoraggio</p>

      <div class="soft-segment-wrapper">
        <ion-segment [(ngModel)]="deviceSettingsMode" (ionChange)="initializer()" mode="ios">
          <ion-segment-button value="simple">
            <ion-label>Semplice</ion-label>
          </ion-segment-button>
          <ion-segment-button value="advanced">
            <ion-label>Avanzata</ion-label>
          </ion-segment-button>
        </ion-segment>
      </div>
    </div>

    <div class="settings-list">
      @for (setting of deviceSettingsData; track $index) {

      <div class="soft-card setting-card">
        <div class="card-header">
          <span class="setting-name" [innerHTML]="setting.name"></span>
        </div>

        <div class="soft-input-wrapper">
          <mat-form-field appearance="fill">
            <mat-label>Modalità</mat-label>
            <mat-select [(ngModel)]="setting.notificationMode"
              (selectionChange)="setting.notificationMode !== 'scheduled' ? setting.schedules = [] : setting.schedules = [{start_time: '00:00', end_time: '00:00'}]"
              panelClass="soft-select-panel">
              <mat-option value="disabled">Disabilitato</mat-option>
              <mat-option value="always_active">Sempre attivo</mat-option>
              <mat-option value="scheduled">Temporizzato</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        @switch (setting.notificationMode) {

        @case ('scheduled') {
        <div class="schedule-container">

          <div class="schedule-labels">
            <span class="lbl-start">INIZIO</span>
            <span class="lbl-arrow"></span>
            <span class="lbl-end">FINE</span>
            <span class="lbl-del"></span>
          </div>

          @for (schedule of setting.schedules; track $index) {
          <div class="schedule-row">

            <div class="soft-input-box">
              <mat-form-field class="naked-field" subscriptSizing="dynamic">
                <mat-select [(ngModel)]="schedule.start_time" panelClass="soft-select-panel">
                  <mat-option *ngFor="let h of hoursList" [value]="h">{{h}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <ion-icon name="arrow-forward" class="divider-icon"></ion-icon>

            <div class="soft-input-box">
              <mat-form-field class="naked-field" subscriptSizing="dynamic">
                <mat-select [(ngModel)]="schedule.end_time" panelClass="soft-select-panel">
                  <mat-option *ngFor="let h of hoursList" [value]="h">{{h}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="action-col">
              <button class="soft-icon-btn danger" *ngIf="setting.schedules.length > 1"
                (click)="setting.schedules.splice($index, 1)">
                <ion-icon name="close"></ion-icon>
              </button>
            </div>

          </div>
          }

          <div style="margin-top: 15px;">
            <button class="soft-btn-add" (click)="setting.schedules.push({start_time: '00:00', end_time: '00:00'})"
              [disabled]="setting.schedules.length > 4">
              <ion-icon name="add"></ion-icon> Aggiungi Fascia
            </button>
          </div>

        </div>
        }

        @case ('always_active') {
        <div class="info-box info">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
          <span>Rilevazione sempre attiva</span>
        </div>
        }
        @case ('disabled') {
        <div class="info-box disabled">
          <ion-icon name="ban-outline"></ion-icon>
          <span>Rilevazione disattivata</span>
        </div>
        }
        }

        @if (setting.id === 'all' || setting.isBedSetting) {
        <div class="soft-input-wrapper extra-margin">
          <mat-form-field appearance="fill">
            <mat-label>Ritardo allerta uscita</mat-label>
            <mat-select [(ngModel)]="setting.bedExitDelay" panelClass="soft-select-panel">
              <mat-option [value]="0">Immediata</mat-option>
              <mat-option [value]="index+1" *ngFor="let _ of [].constructor(30); index as index">{{index+1}}
                min</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        }

        @if (setting.id === 'all' || setting.isBathroomSetting) {
        <div class="soft-input-wrapper extra-margin">
          <mat-form-field appearance="fill">
            <mat-label>Ritardo allerta ingresso bagno</mat-label>
            <mat-select [(ngModel)]="setting.bathroomEntranceDelay" panelClass="soft-select-panel">
              <mat-option [value]="0">Immediata</mat-option>
              <mat-option [value]="minutes" *ngFor="let minutes of bathroomDelayOptions">{{minutes}} min</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        }

        @if (setting.isBedSetting) {
        <div class="bed-in-alert-toggle">
          <mat-slide-toggle [(ngModel)]="setting.disableBedInAlert" color="primary">
            Disattiva notifica entrata letto
          </mat-slide-toggle>
          <span class="toggle-caption">
            Se attivo, per questo letto non verranno inviate notifiche di entrata letto.
          </span>
        </div>
        }

      </div>
      }
    </div>

    <div class="footer-actions">
      <button class="soft-save-btn" (click)="submitData()">
        Salva e Chiudi
      </button>
    </div>

  </div>
</div>
